import { DEFAULT_TRANSITION_TIME_IN_MS } from "src/modules/shared/UI/config";

export const WRITING_MESSAGE_TIME_IN_MS = DEFAULT_TRANSITION_TIME_IN_MS * 6;
